<template>
  <section id="bannerMsj">
    <v-container
      class="extra-padding mx-0 px-0 white--text grey lighten-4"
      fluid
    >
      <!-- <v-parallax dark :src="require('@/assets/hero.jpeg')" class="gradient"> -->
      <v-row align="center" justify="center" class="back mx-0 px-0">
        <v-col class="text-center" cols="12">
          <h1 class="display-1 font-weight-thin mb-4">
            EMPRESA INSCRIPTA EN EL REGISTRO DE DEMOLEDORES Y EXCAVADORES DEL
            GCBA
          </h1>
          <h4 class="subheading">
            Cumplimos con todos los requisitos legales y reglamentarios
            relacionados con nuestra actividad.
          </h4>
        </v-col>
      </v-row>
      <!-- </v-parallax> -->
    </v-container>
    <vertical-divider :class="'vertical'" />
  </section>
</template>

<script>
export default {
  name: "Banner-Msj",
  components: {
    VerticalDivider: () => import("@/components/shape/VerticalDivider.vue")
  }
};
</script>

<style scoped>
.back {
  background-repeat: repeat;
  width: 100%;
  height: 100%;
  min-height: 300px;
  background-color: #03123b;
  background-image: url("data:image/svg+xml,%3Csvg width='44' height='12' viewBox='0 0 44 12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20 12v-2L0 0v10l4 2h16zm18 0l4-2V0L22 10v2h16zM20 0v8L4 0h16zm18 0L22 8V0h16z' fill='%23ffffff' fill-opacity='0.07' fill-rule='evenodd'/%3E%3C/svg%3E");
}
.vertical {
  margin-top: -4.75em !important;
}
/** For tablet devices **/
@media (min-width: 768px) and (max-width: 1023px) {
  .vertical {
    margin-top: -2.55em !important;
  }
}

/** For mobile devices **/
@media (max-width: 767px) {
  .vertical {
    margin-top: -2.5em !important;
  }
}
</style>
